import { render, staticRenderFns } from "./ProductGetOffer.vue?vue&type=template&id=7962a657&"
import script from "./ProductGetOffer.vue?vue&type=script&lang=js&"
export * from "./ProductGetOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports